// frontend/src/stores/titleStore.ts — the mounted page's document-title LEAF.
//
// The tab title is composed centrally in ThemeProvider (which already resolves
// the active project + brand), but the leaf segment ("Sites", "My profile") is
// owned by the page. A page sits BELOW ThemeProvider in the tree, so it pushes
// its leaf up via this tiny store; ThemeProvider composes the full title
// `[leaf, project ?? RubixEMS]` (FRONTEND-PATTERNS §Document title). Zustand,
// not React Context, per CLAUDE.md (no Context for our own state).

import { create } from 'zustand';

interface TitleState {
  segment: string | null;
  setSegment: (segment: string | null) => void;
}

export const useTitleStore = create<TitleState>((set) => ({
  segment: null,
  setSegment: (segment) => set({ segment }),
}));
